var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-typeahead-bootstrap',{attrs:{"size":"sm","value":_vm.value,"data":_vm.fonts,"serializer":item => item.family,"placeholder":"Search fonts...","disable-sort":"","autocomplete":"off"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }